import { createFileRoute } from '@tanstack/react-router'
import { ResellerBalanceTransfersPage } from '@/features/reseller/pages/balance-transfers'

export const Route = createFileRoute('/_authenticated/reseller/balance-transfers')({
  component: ResellerBalanceTransfersPage,
})

